import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const ProfileStyled = styled.div`
    padding: 24px;
    box-shadow: 0px 30px 44px -20px rgb(39, 238, 214, 0.7);

    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 12px;
    }
    
    .accordion, .accordion-button {
        background: var(--color-surface);
    }

    .accordion-button {
        border: 1px solid var(--color-surface);
    }
`;


export const SectionWrapperStyled = styled.div`
    padding: 16px;
    background: var(--color-surface);
    border-radius: 8px;
`;
